import React, { Component } from "react";
import Select from "react-select";

class MultiDropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: [],
      selectedOptionUpdated: [],
      menuIsOpen: false,
    };
  }
  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (this.props.selectGroupId != prevProps.selectGroupId) {
      this.setState({ selectedOption: [], selectedOptionUpdated: [] });
    }
  }

  handleChange = (selectedOption) => {
    if (selectedOption) {
      if (selectedOption.length > 10) {
        alert("Limit of 10 items reached");
      } else {
        this.setState({
          selectedOption: selectedOption,
          selectedOptionUpdated: selectedOption,
        });
        this.props.onParentCall(selectedOption);
      }
    } else {
      this.setState({ selectedOption: [], selectedOptionUpdated: [] });
      this.props.onParentCall([]);
    }
  };

  setMenuIsOpen = (menuOpen) => {
    if (menuOpen === true) {
      this.setState({
        menuIsOpen: menuOpen,
        selectedOptionUpdated: this.state.selectedOption,
      });
    } else {
      if (this.state.menuIsOpen === true) {
        this.setState({ menuIsOpen: menuOpen });
        if (this.state.selectedOption.length > 3) {
          const newLabel = `${this.state.selectedOption.length} ${this.props.fromPOI ? "POIs" : "assets"} selected`;
          const updatedSelectedOptions = this.state.selectedOption.map(
            (option) => ({ ...option, label: newLabel })
          )[0];
          this.setState({ selectedOptionUpdated: updatedSelectedOptions });
        }
      }
    }
  };

  render() {
    const customStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: this.props.modern ? 44 : base.minHeight,
        background: this.props.modern ? "#f8fafc" : "#f2f2f2",
        zIndex: 100,

        // match with the menu
        borderRadius: this.props.modern ? 8 : state.isFocused ? "3px 3px 0 0" : 3,
        // Overwrittes the different states of border
        borderColor: this.props.modern ? state.isFocused ? "#244b8f" : "#dbe4ef" : "#ccc",
        // Removes weird border around container
        boxShadow: this.props.modern && state.isFocused ? "0 0 0 2px rgba(36, 75, 143, 0.14)" : null,
        "&:hover": {
          // Overwrittes the different states of border
          borderColor: this.props.modern ? state.isFocused ? "#244b8f" : "#aebdd0" : "none",
        },
      }),
      multiValue: (styles) => {
        return {
          ...styles,
          backgroundColor: this.props.modern ? "#edf3fb" : "#ffffff",
          zIndex: 100,
        };
      },
      placeholder: (base) => ({
        ...base,
        color: this.props.modern ? "#7e8da1" : base.color,
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: this.props.modern
          ? state.isSelected
            ? "#244b8f"
            : state.isFocused
              ? "#edf3fb"
              : "#fff"
          : base.backgroundColor,
        color: this.props.modern ? state.isSelected ? "#fff" : "#26354f" : base.color,
        fontSize: 13,
      }),
      menu: (base) => ({
        ...base,
        // override border radius to match the box
        borderRadius: this.props.modern ? 8 : 0,
        overflow: this.props.modern ? "hidden" : base.overflow,
        zIndex: 200,

        // kill the gap
        marginTop: this.props.modern ? 4 : 0,
      }),
      menuList: (base) => ({
        ...base,
        // kill the white space on first and last option
        padding: 0,
        zIndex: 100,
      }),
    };
    const options = this.props.assetData.map((element) => {
      return {
        value: element.name,
        label: element.name,
        id: element.id,
      };
    });
    const { selectedOptionUpdated } = this.state;
    const maxSelectionLabel = this.props.maxSelectionLabel || "Select a maximum of 10 vehicles";
    const placeholder = this.props.placeholder || maxSelectionLabel;
    return (
      <div style={{ position: "relative" }}>
        {!this.props.modern && (
          <small
            className="text-muted"
            style={{ position: "absolute", top: "-20px", left: "0" }}
          >
            {(this.state.selectedOption.length > 0)
              && maxSelectionLabel}
          </small>
        )}
        <Select
          value={selectedOptionUpdated}
          isMulti
          styles={customStyles}
          onChange={this.handleChange}
          options={options}
          closeMenuOnSelect={false}
          onMenuOpen={() => this.setMenuIsOpen(true)}
          onMenuClose={() => this.setMenuIsOpen(false)}
          placeholder={placeholder}
        />
      </div>
    );
  }
}

export default MultiDropDown;
